var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon", { attrs: { "with-card": true } }),
      _vm._v(" "),
      !_vm.$store.getters.isExecutingRequest
        ? _c("div", { staticClass: "card shadow-sm" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("pages.subscription.resume.title")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("pages.subscription.resume.want_to_resume")
                  )
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("pages.subscription.resume.will_renew", {
                      date: _vm
                        .$date(this.willBeRenewedAt)
                        .format("DD.MM.YYYY"),
                      price: _vm.renewalPrice + "€"
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-dark",
                  on: { click: _vm.resumeSubscription }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("pages.subscription.resume.confirm")) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }